import React from "react";
import { debounce } from "lodash";

import { Customer } from "../../../models/Booking/Customer";
import { CustomersContactsListStyles } from "./styles.module";
import { CustomersContactsListItem } from "./CustomersContactsListItem";
import { Spinner } from "../../../components/UIKitComponents/Spinner/Spinner";
import { IconInput } from "../IconInput/IconInput";
import { TechniciansActions } from "../../../services/technicians.actions";
import { CustomerActions } from "../../../services/customer.actions";
import { Technician as TechnicianModel } from "../../../../src/models/Technician";
import {
  formattedPhone,
  userFriendlyPhone,
} from "../../../helpers/PhoneHelper";
import { Contact } from "../../types";
import { ContactTypes } from "../../constants";
import Locations from "../../../helpers/Locations";
import socketTest from "../../index";
import {
  DispatchToProps,
  StateToProps,
} from "./CustomersContactsList.Container";

interface ICustomersContactsListProps {}

type Props = ICustomersContactsListProps & StateToProps & DispatchToProps;

export class CustomersContactsList extends React.Component<Props> {
  state: any = {
    searchField: "",
    isSearchLoading: false,
  };

  constructor(props: Props) {
    super(props);
    this.onSearchCustomers = debounce(this.onSearchCustomers.bind(this), 1000);
  }

  goBack() {}

  handleSelectContact(contact: any, index: number) {
    this.props.setActiveContact(contact, index);
    const cnt = new Contact(contact.original);
    socketTest.updateContact(cnt);
  }

  renderList() {
    const searchString = this.props.searchString || "";
    const incomingCounters = this.props.incomingCounters;

    return this.props.contacts
      .filter((it: any) =>
        searchString.length == 0
          ? true
          : it.name
                ?.toLowerCase()
                ?.indexOf(this.props.searchString.toLowerCase()) >= 0
            ? true
            : false
      )
      .map((it: any, index: number) => (
        <CustomersContactsListItem
          key={index}
          contactData={it}
          incomingCounter={incomingCounters[it.original.id] || 0}
          onClick={this.handleSelectContact.bind(this, it, index)}
        />
      ));
  }

  onSearchCustomers = (search: string) => {
    this.setState({
      isSearchLoading: true,
      searchField: search,
    });

    CustomerActions.getByName(search).then((items: any) => {
      this.setSearchLoading(false);

      if (search.length === 0 && items.length === 0) {
        socketTest.requestContacts((contacts) =>
          this.props.loadContacts(contacts)
        );
      } else {
        this.props.loadContacts(
          items.map((it: Customer) => {
            const location = Locations.getPrimary(it);
            const address = Locations.getPrimaryAsString(it);

            return {
              system_item_id: it.id,
              first_name: it.first_name,
              last_name: it.last_name,
              prime_member: !!it.prime_member,
              avatar: "", // it.avatar,

              phone: `+1${formattedPhone(location.phone)}`,
              address: address || "",
              type: ContactTypes.CUSTOMER,
              original: it,
            };
          })
        );
      }
    });
  };

  setSearchLoading(val: boolean) {
    this.setState({
      isSearchLoading: val,
    });
  }

  render() {
    const isSearchable = this.state.searchField.length > 0;
    const isSearchLoading = this.state.isSearchLoading;
    const hasSelectedWorkspace = this.props.selectedWorkspace !== null;

    return (
      <CustomersContactsListStyles>
        {hasSelectedWorkspace ? (
          ""
        ) : (
          <div className="cl__search">
            <div className="cl__search-wrap">
              <IconInput
                value={this.props.searchString}
                placeholder="Search"
                masked
                mask="(999) 999-9999"
                onChange={(e) => {
                  let phone = e.target.value;
                  if (phone.length === 10 && isNaN(+phone) === false) {
                    phone = userFriendlyPhone(phone);
                  }

                  this.setSearchLoading(this.props.searchString !== phone);
                  this.onSearchCustomers(phone);
                }}
              />
            </div>

            {isSearchable ? (
              <div className="cl__search-result-space"></div>
            ) : (
              ""
            )}
            {isSearchable ? (
              <div className="cl__search-result">
                <span>SEARCH RESULTS:</span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
        <ul className="cl">
          {isSearchLoading ? (
            <Spinner fit color="#3333cc" size={14} margin={3} />
          ) : (
            ""
          )}
          {this.renderList.call(this)}
        </ul>
      </CustomersContactsListStyles>
    );
  }
}
